import React from "react";
import { VStack } from "@chakra-ui/react";
import { Switch, Form } from "components";
import { useCurrentCase } from "duck";
import { hooks } from "./duck";

const Treatments: React.FC = () => {
  const defaultValues = useCurrentCase(medicalCase => {
    const { treatment } = medicalCase.data.client.patient;
    return {
      microchip: treatment?.microchip || false,
      laserTherapy: treatment?.laserTherapy || false,
      cereniaInjection: treatment?.cereniaInjection || false
    };
  });

  const update = hooks.useUpdateTreatments();

  return (
    <Form defaultValues={defaultValues}>
      <Form.Watcher defaultValues={defaultValues} onChange={update} />
      <VStack spacing={6}>
        <Switch name="microchip" label="Microchip" />
        <Switch name="cereniaInjection" label="Cerenia Injection" />
        <Switch name="laserTherapy" label="Laser Therapy" />
      </VStack>
    </Form>
  );
};

export default Treatments;
